const rehype = require('rehype');
const sanitize = require('rehype-sanitize');
const schema = require('./schema-hast-sanitize.json');

module.exports = {
  sanitize: markdown => rehype().use(sanitize, schema).processSync(markdown).toString()
};
